import { http } from 'core/utils/httpClient';
import type { ShopResponse } from './dtoModels/shop/shopResponse';
import type { UpdateShopRequest } from './dtoModels/shop/updateShopRequest';
import type { Shop } from 'models/shop/shop';

export async function getShopAsync(id: number): Promise<Shop> {
  const { data } = await http.get<ShopResponse>(`shops/${id}`);

  return data;
}

export async function updateShopAsync(
  id: number,
  request: UpdateShopRequest
): Promise<Shop> {
  const { data } = await http.put<ShopResponse>(`shops/${id}`, request);

  return data;
}
